import { useRoute } from 'hooks/navigation/use-route';
import { LoyaltyEngineId } from 'state/loyalty/types';

interface ILoyaltyOffersParams {
  offerEngineId?: LoyaltyEngineId;
}

interface ILoyaltyOffersFlow {
  loyaltyEngineId: LoyaltyEngineId;
}

// This hook should be removed when we split OfferList from OfferDetails components
const useLoyaltyOffersFlow = (): ILoyaltyOffersFlow => {
  const { params } = useRoute<ILoyaltyOffersParams>();
  const loyaltyEngineId = (params?.offerEngineId || '').trim() as LoyaltyEngineId;

  return {
    loyaltyEngineId,
  };
};

export default useLoyaltyOffersFlow;
